export default __webpack_public_path__ + "static/media/caret-down1.eff699e7.svg";